var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-link',{staticClass:"mobile-nav-trigger p-2",on:{"click":function($event){_vm.sidebarState = !_vm.sidebarState}}},[_c('font-awesome-icon',{attrs:{"size":"lg","icon":['fas', 'bars']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }